if (!customElements.get('wls-header-lp')) {
  class WLSHeaderLP extends HTMLElement {
  constructor() {
    super();
    this.classes = {
      cartCount: '[data-cart-count]'
    };
  }

  connectedCallback() {
    this.updateCartCount();
    this.setupCartListeners();
  }

  disconnectedCallback() {
    if (this.cartUpdateHandler) {
      document.removeEventListener('cart:updated', this.cartUpdateHandler);
    }
  }

  updateCartCount() {
    const cartCountElements = this.querySelectorAll(this.classes.cartCount);
    
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const count = cart.item_count || 0;
        cartCountElements.forEach(el => {
          if (count > 0) {
            el.textContent = count;
            el.style.display = 'flex';
          } else {
            el.textContent = '0';
            el.style.display = 'none';
          }
        });
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });
  }

  setupCartListeners() {
    this.cartUpdateHandler = () => {
      this.updateCartCount();
    };

    document.addEventListener('cart:updated', this.cartUpdateHandler);
    document.addEventListener('cart:refresh', this.cartUpdateHandler);
    
    document.addEventListener('cart:add', this.cartUpdateHandler);
    document.addEventListener('cart:change', this.cartUpdateHandler);
    document.addEventListener('cart:remove', this.cartUpdateHandler);
  }
}
  customElements.define('wls-header-lp', WLSHeaderLP);
}
